import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    clearAuthorizationNotice,
    peekAuthorizationNotice,
    UNAUTHORIZED_CURRENT_USER
} from '../../utilities/AuthorizationNoticeUtility';
import ErrorAlert from './Alerts';

function AuthorizationNotice() {
  const [notice, setNotice] = useState(() => peekAuthorizationNotice());
  const {t} = useTranslation();

  useEffect(() => {
    clearAuthorizationNotice();
  }, []);

  if (notice !== UNAUTHORIZED_CURRENT_USER) {
    return null;
  }

  return <ErrorAlert
    severity='error'
    open
    message={t('account.text.unauthorized')}
    handleClose={() => setNotice(undefined)}
  />;
}

export default AuthorizationNotice;